import { Component, Input, OnInit, OnDestroy, ViewContainerRef, ViewChild, EventEmitter, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { PinPanelService } from '../../services/pin-panel.service';
import { BoardHeader } from '../../entities/board.entity';
import { ModalService } from '../../services/modal.service';
import { PinManagerModalComponent } from '../pin-manager-modal/pin-manager-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { WebArticle } from '../../entities/web-article';

@Component({
  selector: 'app-pin-manager-button',
  templateUrl: './pin-manager-button.component.html',
  styleUrls: ['./pin-manager-button.component.scss']
})
export class PinManagerButtonComponent implements OnInit, OnDestroy {
  @Input() panelPosition: 'left' | 'right' = 'left';
  @Input() panelId!: any;
  @Input() boards: BoardHeader[] = [];
  @Input() article!: WebArticle;
  @Output() onSuccess: EventEmitter<any> = new EventEmitter();

  panelVisible = false;
  panelStyle = {};
  private subscription: Subscription = new Subscription();

  constructor(private pinPanelService: PinPanelService, public modalService: ModalService, public dialog: MatDialog) { }

  ngOnInit() {
    this.subscription.add(this.pinPanelService.panelOpened$.subscribe((openedPanelId) => {

      if (openedPanelId !== null && openedPanelId !== this.panelId) {
        this.panelVisible = false;
      }
    }));
  }

  openModal() {
    const dialogRef = this.dialog.open(PinManagerModalComponent, {
      width: '500px',
      height: '600px',
      panelClass: 'app-modal',
      data: {
        boards: this.boards,
        article: this.article
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.onSuccess.emit(result.success);
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  togglePanel(event: MouseEvent) {
    const shouldBeVisible = !this.panelVisible;
    this.pinPanelService.openPanel(shouldBeVisible ? this.panelId : null);
    this.panelVisible = shouldBeVisible;

    if (this.panelVisible) {
      const button = (event.target as HTMLElement).closest('button');
      if (!button) return;

      const rect = button.getBoundingClientRect();
      this.panelStyle = this.calculatePanelStyle(rect);
    }
  }

  private calculatePanelStyle(rect: DOMRect) {
    return this.panelPosition === 'right' ? {
      top: `${rect.top}px`,
      left: `${rect.right}px`,
    } : {
      top: `${rect.top}px`,
      left: `${rect.left - 255}px`,
    };
  }
}
